import React from 'react';
import './Feature.css';
import { motion } from 'framer-motion';
import { FaUserAlt, FaDollarSign, FaWallet, FaStore } from 'react-icons/fa';
import { IoRocketSharp } from 'react-icons/io5';
import { useLanguage } from "../../contexts/LanguageContext";

const Feature = () => {
  const { translations: t } = useLanguage();

  const features = [
    {
      icon: <FaUserAlt className="feature-icon-svg" />,
      title: t.features?.customFeed?.title || 'A social networking platform and digital marketplace',
      description: t.features?.customFeed?.description || 'Share your ideas with the community—whether you are a company or an individual—and showcase your services or products to grow your business.',
      color: '#6366f1'
    },
    {
      icon: <FaDollarSign className="feature-icon-svg" />,
      title: t.features?.earnPosts?.title || 'Earn With Every Post',
      description: t.features?.earnPosts?.description || 'Activate reward options through your shared content or tailor posts for specific audiences. Each interaction opens the door to earning digital incentives and maximizing your visibility.',
      color: '#10b981'
    },
    {
      icon: <FaWallet className="feature-icon-svg" />,
      title: t.features?.walletPerks?.title || 'Generate Continuous Revenue',
      description: t.features?.walletPerks?.description || 'Earn rewards and engage with other’s posts to collect (Tokens), which are converted into your digital wallet and used as currency both inside and outside the app.',
      color: '#f59e0b'
    },
    {
      icon: <FaStore className="feature-icon-svg" />,
      title: t.features?.builtForStores?.title || 'A New Advertising Platform',
      description: t.features?.builtForStores?.description || 'Showcase or sell your service or product and promote it using a variety of built-in tools available within the platform.',
      color: '#3b82f6'
    },
  ];

  return (
    <section className="features-section" id="features">
      <div className="features-container">
        <motion.div 
          className="features-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <IoRocketSharp className="rocket-icon" />
          <motion.h2
            className="features-title"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {t.whyIwinto || "Why iWinto is Different"}
          </motion.h2>
          <motion.p
            className="features-subtitle"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            {t.featuresSubtitle || "Innovative features that set us apart"}
          </motion.p>
        </motion.div>

        <div className="features-grid">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ 
                type: "spring",
                stiffness: 100,
                damping: 10,
                delay: idx * 0.15
              }}
              viewport={{ once: true, margin: "-50px" }}
            >
              <motion.div 
                className="feature-icon-container"
                style={{ backgroundColor: `${feature.color}10` }}
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <div className="feature-icon" style={{ color: feature.color }}>
                  {feature.icon}
                </div>
              </motion.div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.description}</p>
              <motion.div 
                className="feature-highlight"
                style={{ backgroundColor: feature.color }}
                initial={{ width: 0 }}
                whileInView={{ width: "100%" }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Feature;